module.exports = __webpack_public_path__ + "media/components/footer/static/sfc--white-4f5758ee8b407fec00f6e4af33d98d38.svg";